export default __webpack_public_path__ + "static/media/iconFaTrash.bef499c6.svg";